import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['submit']

  connect() {
    this.update()
  }

  update() {
    const checkboxes = this.element.querySelectorAll('input[type="checkbox"][required]')
    if (checkboxes.length === 0) return

    const allChecked = Array.from(checkboxes).every(cb => cb.checked)
    this.submitTargets.forEach(btn => { btn.disabled = !allChecked })
  }
}
